
import WelcomePage from 'pages/WelcomePage/WelcomePage';
import CategoryProductsPage from 'pages/CategoryProductsPage/CategoryProductsPage';
import ProductPage from 'pages/ProductPage/ProductPage';
import ProfilePage from 'pages/ProfilePage/ProfilePage';
import FeedbackPage from 'pages/FeedbackPage/FeedbackPage';
import TelegramCallbackPage from 'pages/TelegramCallbackPage/TelegramCallbackPage';
import PersonalPanelPage from 'pages/PersonalPanelPage/PersonalPanelPage';

// Static pages
import AboutUsPage from 'pages/WelcomePage/pages/AboutUsPage/AboutUsPage';
import ContactsPage from 'pages/WelcomePage/pages/ContactsPage/ContactsPage';
import PrivacyPolicyPage from 'pages/WelcomePage/pages/PrivacyPolicyPage/PrivacyPolicyPage';
import InternetSpeedPage from 'pages/WelcomePage/pages/InternetSpeedPage/InternetSpeedPage';
import AIPage from 'pages/AIPage/AIPage';
import ServicesPage from 'pages/ServicesPage/ServicesPage';
import TermsPage from 'pages/TermsPage/TermsPage';

// Service pages
import ShopPage from 'pages/Services/ShopPage/ShopPage';
import FoodPage from 'pages/Services/FoodPage/FoodPage';
import ITPage from 'pages/Services/ITPage/ITPage';
import ServersPage from 'pages/Services/ServersPage/ServersPage';
import CommunityPage from 'pages/Services/CommunityPage/CommunityPage';
import MoviePage from 'pages/Services/MoviePage/MoviePage';
import AnimePage from 'pages/Services/AnimePage/AnimePage';
import AnimePlayerPage from 'pages/AnimePlayerPage/AnimePlayerPage';
import MoviePlayerPage from 'pages/MoviePlayerPage/MoviePlayerPage';
import EventsPage from 'pages/Services/EventsPage/EventsPage';
import MediaPage from 'pages/Services/MediaPage/MediaPage';
import TourismPage from 'pages/Services/TourismPage/TourismPage';
import MusicPage from 'pages/Services/MusicPage/MusicPage';
import DonationsPage from 'pages/DonationsPage/DonationsPage';
import DonationHistoryPage from 'pages/DonationHistoryPage/DonationHistoryPage';
import FavoritesPage from 'pages/FavoritesPage/FavoritesPage';
import CookiePolicyPage from 'pages/CookiePolicyPage/CookiePolicyPage';
import ChatsPage from 'pages/ChatsPage/ChatsPage';
import NcoreHubPage from 'pages/NcoreHub/NcoreHubPage';
import NcoreHubRepo from 'pages/NcoreHub/NcoreHubRepo';

// import SiteMapPage from 'pages/SiteMapPage/SiteMapPage';

// All routes rendered inside MainLayout (persistent header + footer)
export const layoutRoutes = [
  { path: '/', component: <WelcomePage /> },

  // Telegram OAuth callback
  { path: '/tg-auth', component: <TelegramCallbackPage /> },

  // Core pages
  { path: '/profile', component: <ProfilePage /> },
    { path: '/personal-panel', component: <PersonalPanelPage /> },
  { path: '/feedback', component: <FeedbackPage /> },
  { path: '/about', component: <AboutUsPage /> },
  { path: '/contacts', component: <ContactsPage /> },
  { path: '/privacy', component: <PrivacyPolicyPage /> },
  { path: '/terms-and-conditions', component: <TermsPage /> },
  { path: '/ai', component: <AIPage /> },
  { path: '/speedtest', component: <InternetSpeedPage /> },
  { path: '/services', component: <ServicesPage /> },

  // Catalog
  { path: '/catalog', component: <CategoryProductsPage /> },
  { path: '/product', component: <ProductPage /> },

  // Service pages (embedded=true so they don't render their own header)
  { path: '/services/shop', component: <ShopPage embedded={true} /> },
  { path: '/services/food', component: <FoodPage embedded={true} /> },
  { path: '/services/it', component: <ITPage embedded={true} /> },
  { path: '/services/servers', component: <ServersPage embedded={true} /> },
  { path: '/services/community', component: <CommunityPage embedded={true} /> },
  { path: '/services/community/posts', component: <CommunityPage embedded={true} /> },
  { path: '/services/community/chats', component: <CommunityPage embedded={true} /> },
  { path: '/services/community/forums', component: <CommunityPage embedded={true} /> },
  { path: '/services/movie', component: <MoviePage embedded={true} /> },
  { path: '/services/movie/watch/:mediaId', component: <MoviePlayerPage /> },
  { path: '/services/anime', component: <AnimePage embedded={true} /> },
  { path: '/services/anime/watch/:mediaId', component: <AnimePlayerPage /> },
  { path: '/services/events', component: <EventsPage embedded={true} /> },
  { path: '/services/media', component: <MediaPage embedded={true} /> },
  { path: '/services/tourism', component: <TourismPage embedded={true} /> },
  { path: '/services/music', component: <MusicPage embedded={true} /> },

  // Donations
  { path: '/services/donations', component: <DonationsPage /> },
  { path: '/services/donation-history', component: <DonationHistoryPage /> },

  // Favorites
  { path: '/favorites', component: <FavoritesPage /> },

  // Chats page (standalone)
  { path: '/chats', component: <ChatsPage /> },

  // NcoreHub - repository management
  { path: '/ncoreboard', component: <NcoreHubPage /> },
  { path: '/ncoreboard/:owner/:repo', component: <NcoreHubRepo /> },

  // Legal / Cookie
  { path: '/cookie-policy', component: <CookiePolicyPage /> },

  // { path: '/sitemap', component: <SiteMapPage /> },
];

// Flat list for backward-compat checks (e.g. isNoMatchPage in App.js)
export const routes = layoutRoutes;
